import { render } from "./addTicket.vue?vue&type=template&id=afdd33ce&scoped=true"
import script from "./addTicket.vue?vue&type=script&lang=js"
export * from "./addTicket.vue?vue&type=script&lang=js"

import "./addTicket.vue?vue&type=style&index=0&id=afdd33ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdd33ce"]])

export default __exports__